import { useSelector } from "react-redux"
import { getAuth } from "../store/features/authSlice"
import { Grid, Paper } from "@mui/material"
import { Template } from "../components/Template"
import { UsersForRoleChart } from "../components/charts/user/UsersForRoleChart"
import { UsersForChapterChart } from "../components/charts/user/UsersForChapterChart"
import { IncomeForDayChart } from "../components/charts/transaction/IncomeForDayChart"
import { InteractionsForDayChart } from "../components/charts/post/InteractionsForDayChart"
import { IncomeForPaymentMethodForDayChart } from "../components/charts/transaction/IncomeForPaymentMethodForDayChart"
import { IncomeForPaymentTypeForDayChart } from "../components/charts/transaction/IncomeForPaymentTypeForDayChart"

export const HomeScreen = () => {
  const auth = useSelector(getAuth)

  return (
    <Template>
      <Grid item xs={6}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minHeight: 300,
          }}
        >
          <InteractionsForDayChart />
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minHeight: 300,
          }}
        >
          <IncomeForDayChart />
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minHeight: 300,
          }}
        >
          <IncomeForPaymentMethodForDayChart />
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minHeight: 300,
          }}
        >
          <IncomeForPaymentTypeForDayChart />
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minHeight: 300,
          }}
        >
          <UsersForRoleChart />
        </Paper>
      </Grid>
      <Grid item xs={8}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minHeight: 400,
          }}
        >
          <UsersForChapterChart />
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minHeight: 400,
          }}
        ></Paper>
      </Grid>
    </Template>
  )
}
